import * as $ from "jquery"
import { Swiper, SwiperOptions, Navigation} from 'swiper';
import 'swiper/swiper-bundle.css';

const init = ()=> {

    let servicesSliderClass = "js-services-slider";

    $(`.${servicesSliderClass}`).each((i,element) => {
        const $parent = $(element).closest(".services-slider__wrapper");

        let serviceTitles = $("[data-service-title]").toArray().map(element => $(element).text());

        const swiper = new Swiper(element, {
            slidesPerView: 1,
            spaceBetween: 10,
            effect: "fade",
            pagination: {
                el: ".swiper-pagination, .services-slider__custom-pagination",
                clickable: true,
                renderBullet: (index, className) => {
                    return `<div class="${className}"><span>${serviceTitles[index]}</span></div>`;
                },
            },
            navigation: {
                nextEl: $parent.find(".services-slider__next")[0],
                prevEl: $parent.find(".services-slider__prev")[0],
            },
        });
    });
}

export const servicesSlider = {
	init: init
};